export default __webpack_public_path__ + "static/media/Blog.2279470d.png";